import { FC } from 'react';
import { ProInput } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import { TextAreaProps } from 'antd/lib/input';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormTextAreaProps extends BaseSearchFormItemProps {
  /** textArea Props */
  textAreaProps?: TextAreaProps;
}
/** 文本区域 */
export const SearchFormTextArea: FC<SearchFormTextAreaProps> = props => {
  const {
    textAreaProps,
    form,
    isDetail,
    isTable,
    testId,
    name,
    render,
    disabledRender,
    label,
    rules,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      name={name}
      label={label}
      rules={rules}
      disabled={isDetail || textAreaProps?.disabled}
    >
      {isDetail || (textAreaProps && textAreaProps.disabled) ? (
        <SearchFormDisabled
          name={name}
          form={form}
          render={render || disabledRender}
          isTable={isTable}
        />
      ) : (
        <ProInput.TextArea
          {...textAreaProps}
          placeholder={getInputPlaceholder(label, textAreaProps, rules)}
          test-id={`${testId}-${name}`}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormTextArea.displayName = SearchFormItemEnum.SearchFormTextArea;

export default SearchFormTextArea;
